<template>

    <div>

        <span v-if="!data.moderated">

            <span class="flex flex-row">
    <!--            <i class="material-icons mr-2 pl-2 pt-2 cursor-pointer w-10 h-10 icon-circled-darkest">person</i>-->
    <!--            <img class="mr-2 pl-2 pt-2 cursor-pointer w-10 h-10" :src="commentUserAvatar" :alt="data.owner.name" />-->
                <img class="mr-2 pl-2 pt-2 cursor-pointer w-12 h-12" :src="commentUserAvatar" :alt="data.owner.name" />
                <span class="flex flex-col">
                    <h3 class="font-bold text-sm pb-2 text-theme-discrete">{{ data.owner.name }},<span class="font-normal text-theme-muted">{{ translate('comments-on') }}{{ commentDate }} ({{ elapsedTime }}),{{ translate('comments-said') }}</span></h3>
                    <div class="flex flex-row">
                        <p v-if="!data.moderated" class="mb-2">{{ data.body }}</p>
                        <!-- <p v-else class="text-theme-muted text-sm italic">{{ translate('content-moderated-message') }}</p> -->
                            <i v-if="!data.moderated && userAuthenticated && ((userRole === 'superadmin') || (userRole === 'admin') || (userRole === 'author'))"
                               class="material-icons ml-2 text-red-300 hover:text-red-500 cursor-pointer" :title="translate('content-moderate-on')"
                               @click="moderateComment"
                            >visibility_off</i>
                            <i v-if="data.moderated && userAuthenticated && ((userRole === 'superadmin') || (userRole === 'admin') || (userRole === 'author'))"
                               class="material-icons ml-2 text-red-300 hover:text-red-500 cursor-pointer" :title="translate('content-moderate-off')"
                               @click="restoreComment"
                            >visibility</i>

                    </div>
                    <p v-if="data.moderated && userAuthenticated && ((userRole === 'superadmin') || (userRole === 'admin') || (userRole === 'author'))" class="mb-2"><span class="text-red-500 text-sm">Original: </span><span class="text-red-300 text-sm">{{ data.body }}</span></p>
    <!--                <i class="material-icons mr-2 pl-2 pt-2 cursor-pointer w-10 h-10 icon-circled-darkest">visibility</i>-->
                </span>
            </span>

            <div v-if="currentUser" class="ml-12">
                <comment-form v-if="!data.moderated" :language="language" :content_id="content_id" :parent_id="data.id" :button_label="translate('comments-post-reply')"></comment-form>
            </div>
            <div v-else class="ml-12 mb-6">
                <p v-if="!data.moderated" class="text-sm text-theme-muted">{{ translate('comments-login-to-reply') }}</p>
            </div>

            <div v-if="allComments[data.id] && !repliesAreVisible" class="text-sm font-bold mb-4 ml-6 ml-12 text-blue-500 cursor-pointer hover:underline" @click="repliesAreVisible=true">{{ translate('comments-show-replies') }}</div>
            <div v-if="allComments[data.id] && repliesAreVisible" class="text-sm font-bold mb-4 ml-6 ml-12 text-blue-500 cursor-pointer hover:underline" @click="repliesAreVisible=false">{{ translate('comments-hide-replies') }}</div>

                <span v-if="allComments[data.id] && repliesAreVisible">
                    <comment-list :language="language" :content_id="content_id" :data_key="data.id"></comment-list>
                </span>

        </span>

    </div>

</template>

<script>

    import moment from 'moment-timezone';

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {


        props: [
            'language',
            'data',
            'content_id'
        ],

        data() {

            return {

                currentUser: Laravel.user,
                commentDate: moment(this.data.created_at).format('DD-MM-YYYY'),

                repliesAreVisible: false

            }
        },

        computed: {

            allComments() {

                return this.$root.shared.full_comment_data

            },

            commentUserAvatar() {
                return window.Laravel.publicFolder + '/avatars/' + this.data.owner.avatar + '.png'
            },

            elapsedTime() {

                moment.locale( this.language==='es' ? 'es' : 'en' );
                // return moment.duration(moment().diff(this.data.created_at)).humanize();
                return moment(this.data.created_at).fromNow();

            },

            userAuthenticated() {
                return window.Laravel.user
            },

            userRole() {
                return window.Laravel.userRole
            }

        },

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            moderateComment() {

                if(confirm(this.translate('comments-are-you-sure'))) {

                    axios.get('/' + this.language + '/comment/hide/' + this.data.id)
                        .then((response) => {
                            // window.location.reload();
                            console.log('Comment ID: ' + this.data.id + ' has been marked as MODERATED!')

                            axios.get('/api/comments/' + this.content_id)
                                .then((response) => {
                                    this.$root.shared.full_comment_data = response.data
                                })
                                .catch((error) => {
                                    console.log('Error obtaining COMMENTS data: ' + error)
                                })

                        })
                        .catch((error) => {
                            console.log('Error marking Comment as MODERATED: ' + error);
                        });
                }

            },

            restoreComment() {

                axios.get('/' + this.language  + '/comment/show/' + this.data.id)
                    .then((response) => {
                        // window.location.reload();
                        console.log('Comment ID: ' + this.data.id + ' has been marked as NOT MODERATED!')

                        axios.get('/api/comments/' + this.content_id)
                            .then((response) => {
                                this.$root.shared.full_comment_data = response.data
                            })
                            .catch((error) => {
                                console.log('Error obtaining COMMENTS data: ' + error)
                            })
                    })
                    .catch((error) => {
                        console.log('Error marking Comment as NOT MODERATED: ' + error);
                    });

            },


        },

        created() {

            moment.updateLocale('en', {
                relativeTime: {
                    future: "in %s",
                    past: "%s ago",
                    s: 'a few seconds',
                    ss: '%d seconds',
                    m: "a minute",
                    mm: "%d minutes",
                    h: "an hour",
                    hh: "%d hours",
                    d: "a day",
                    dd: "%d days",
                    w: "a week",
                    ww: "%d weeks",
                    M: "a month",
                    MM: "%d months",
                    y: "a year",
                    yy: "%d years"
                }
            });

            moment.updateLocale('es', {
                relativeTime : {
                    future: "en %s",
                    past:   "hace %s",
                    s  : 'unos segundos',
                    ss : '%d segundos',
                    m:  "un minuto",
                    mm: "%d minutos",
                    h:  "una hora",
                    hh: "%d horas",
                    d:  "un dia",
                    dd: "%d días",
                    w:  "una semana",
                    ww: "%d semanas",
                    M:  "un mes",
                    MM: "%d meses",
                    y:  "un año",
                    yy: "%d años"
                }
            });

        }

    }

</script>
